import React from 'react';
import { ChevronDown, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { projectInfo } from '../data/mock';

const HeroSection = ({ onEnquireClick }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://embassyverde.com/images/banner.jpg"
          alt="Embassy Verde 2.0 - Luxury Apartments at Embassy Springs Devanahalli Bangalore"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628]/80 via-[#0a1628]/60 to-[#0a1628]/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#c9a961]/20 backdrop-blur-sm border border-[#c9a961]/30 rounded-full px-4 sm:px-6 py-2 mb-6 sm:mb-8">
          <Sparkles className="w-4 h-4 text-[#c9a961]" />
          <span className="text-[#c9a961] text-xs sm:text-sm font-medium tracking-wider">EMBASSY NEW LAUNCH 2026</span>
        </div>

        {/* Main Title */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          <span className="block">Experience Luxury at</span>
          <span className="block mt-2 bg-gradient-to-r from-[#c9a961] via-[#e8d5a3] to-[#c9a961] bg-clip-text text-transparent">
            Embassy Verde 2.0
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl md:text-2xl text-white/80 mb-2 sm:mb-4 font-light">
          {projectInfo.tagline}
        </p>
        <p className="text-sm sm:text-lg text-white/60 mb-6 sm:mb-8">
          Embassy Springs Verde - {projectInfo.location}
        </p>

        {/* Price Badge */}
        <div className="inline-flex flex-col sm:flex-row items-center gap-2 sm:gap-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-6 sm:px-8 py-4 mb-8 sm:mb-10">
          <div className="text-center sm:text-left">
            <p className="text-white/60 text-xs sm:text-sm">Embassy Verde Apartments From</p>
            <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#c9a961]">
              ₹{projectInfo.priceStarting}
            </p>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20" />
          <div className="text-center sm:text-left">
            <p className="text-white/60 text-xs sm:text-sm">RERA Approved</p>
            <p className="text-white text-xs sm:text-sm font-medium">Verified Project</p>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Button
            onClick={onEnquireClick}
            size="lg"
            className="w-full sm:w-auto bg-gradient-to-r from-[#c9a961] to-[#a08545] hover:from-[#d4b76d] hover:to-[#b8964d] text-[#0a1628] font-bold px-8 sm:px-10 py-5 sm:py-6 rounded-full text-base sm:text-lg transition-all duration-300 hover:shadow-2xl hover:shadow-[#c9a961]/40 hover:scale-105"
          >
            Get Best Offers
          </Button>
          <Button
            variant="outline"
            size="lg"
            onClick={() => document.querySelector('#pricing')?.scrollIntoView({ behavior: 'smooth' })}
            className="w-full sm:w-auto border-2 border-white/30 bg-white/5 backdrop-blur-sm text-white hover:bg-white/10 hover:border-white/50 px-8 sm:px-10 py-5 sm:py-6 rounded-full text-base sm:text-lg transition-all duration-300"
          >
            View Price List
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => document.querySelector('#overview')?.scrollIntoView({ behavior: 'smooth' })}
          className="text-white/60 hover:text-[#c9a961] transition-colors"
          aria-label="Scroll to overview section"
        >
          <ChevronDown className="w-6 sm:w-8 h-6 sm:h-8" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
